class QuickBuy extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <div role="dialog" aria-modal="true" aria-label="Quick Buy" tabindex="-1" class="qb-drawer fixed top-0 right-0 bottom-0 z-40 w-[calc(100%-20px)] md:w-full max-w-122.5 translate-x-full transition-transform duration-300 ease-out bg-royal-white flex flex-col outline-none" style="view-transition-name:qb-drawer"></div>
    `;
    this._drawer = this.querySelector('.qb-drawer');

    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-quick-buy]');
      if (btn) {
        e.preventDefault();
        // Close any open custom-modal (e.g. Shop the Look) before opening QB.
        // Force-hide the backdrop instantly so it doesn't overlap QB's backdrop.
        const openModal = document.querySelector('custom-modal');
        if (openModal && typeof openModal.closeAll === 'function') openModal.closeAll();
        this.open(btn.dataset.productHandle);
        return;
      }

      if (e.target.closest('[data-quick-buy-close]')) { this.close(); return; }
      if (e.target === this) { this.close(); return; }

      const swatch = e.target.closest('[data-swatch]');
      if (swatch && this._drawer.contains(swatch)) {
        e.preventDefault();
        const href = swatch.getAttribute('href');
        const handle = href.split('/products/')[1]?.split('?')[0];
        if (handle) this.open(handle);
        return;
      }
    });

    this._drawer.addEventListener('change', e => {
      const fs = e.target.closest('fancy-select[data-qb-team]');
      if (!fs) return;
      const handle = e.detail?.value?.split('/products/')[1]?.split('?')[0];
      if (handle) this.open(handle);
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this._open) this.close();
    });

    this._drawer.addEventListener('submit', e => {
      if (e.target.closest('[action*="cart/add"]') && !e.defaultPrevented) this.close(true);
    });

    document.addEventListener('intersection:loaded', () => {
      if (!this._pendingLoad) return;
      if (!this._drawer.querySelector('[data-product-variants]')) return;
      this._pendingLoad = false;
      this._initDrawerProduct();
    });
  }

  open(handle) {
    this._currentHandle = handle;

    if (this._open) {
      this._reload(handle);
      return;
    }

    this._pendingLoad = true;
    this._drawer.innerHTML = `
      <intersection-loader
        data-url="/products/${handle}"
        data-section-id="quick-buy"
        data-load-immediately="true"
        class="flex-1"
      ></intersection-loader>
    `;

    this._opener = document.activeElement;
    this.classList.add('qb-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      this._drawer.classList.remove('translate-x-full');
      this._drawer.focus();
    });
    this._open = true;
  }

  async _reload(handle) {
    const url = `/products/${handle}?section_id=quick-buy`;
    let html;
    try { html = await fetch(url).then(r => r.text()); } catch { return; }

    const temp = document.createElement('div');
    temp.innerHTML = html;
    const newSection = temp.querySelector('#shopify-section-quick-buy');
    if (!newSection) return;

    const body = this._drawer.querySelector('.qb-body');
    const newBody = newSection.querySelector('.qb-body');
    if (!body || !newBody) return;

    const swap = () => {
      body.innerHTML = newBody.innerHTML;
      const variantsEl = newSection.querySelector('[data-product-variants]');
      if (variantsEl) {
        try { window.productVariants = JSON.parse(variantsEl.textContent); } catch { window.productVariants = []; }
      }
      this._drawer.querySelectorAll('fancy-select[data-navigate]').forEach(fs => {
        fs.setAttribute('data-qb-team', '');
        fs.removeAttribute('data-navigate');
      });
      if (typeof initProduct === 'function') initProduct(this._drawer);
      if (window.jdgm?.customWidgetsInit) window.jdgm.customWidgetsInit();
      this._syncReviewCount();
    };

    if (document.startViewTransition) {
      await document.startViewTransition(swap).finished;
    } else {
      swap();
    }
  }

  close(instant = false) {
    if (instant) {
      this._drawer.style.transition = 'none';
      requestAnimationFrame(() => { this._drawer.style.transition = ''; });
    }
    this._drawer.classList.add('translate-x-full');
    document.body.style.overflow = '';
    this._open = false;
    this._opener?.focus();
    this._opener = null;
    setTimeout(() => {
      if (!this._open) {
        this._reviewObserver?.disconnect();
        this.classList.remove('qb-open');
        this._drawer.innerHTML = '';
      }
    }, instant ? 0 : 310);
  }

  _initDrawerProduct() {
    const variantsEl = this._drawer.querySelector('[data-product-variants]');
    if (variantsEl) {
      try { window.productVariants = JSON.parse(variantsEl.textContent); } catch { window.productVariants = []; }
    }

    this._drawer.querySelectorAll('fancy-select[data-navigate]').forEach(fs => {
      fs.setAttribute('data-qb-team', '');
      fs.removeAttribute('data-navigate');
    });

    if (typeof initProduct === 'function') initProduct(this._drawer);
    if (window.jdgm?.customWidgetsInit) window.jdgm.customWidgetsInit();
    this._syncReviewCount();
  }

  _syncReviewCount() {
    const widget = this._drawer.querySelector('.jdgm-widget');
    const span = this._drawer.querySelector('[data-reviews-count]');
    if (!widget || !span) return;
    const sync = () => {
      const text = widget.querySelector('.jdgm-prev-badge__text')?.textContent ?? '';
      const match = text.match(/\d[\d,]*/);
      span.textContent = match ? `(${match[0]})` : '';
    };
    sync();
    this._reviewObserver?.disconnect();
    this._reviewObserver = new MutationObserver(sync);
    this._reviewObserver.observe(widget, { childList: true, subtree: true, characterData: true });
  }
}

customElements.define('quick-buy', QuickBuy);
